var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { attrs: { modalId: "account-needs-attention", size: "modal-md" } },
    [
      _c(
        "ModalHeader",
        {
          style: { padding: "10px 10px 10px 10px" },
          attrs: {
            title: _vm.$t("xYourAccountNeedsAttentionHeader"),
            icon: "far fa-exclamation-triangle"
          }
        },
        [
          _c("div", { staticClass: "cols-auto" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-icon-button btn-icon-button--gray",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal("account-needs-attention")
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ])
        ]
      ),
      _c("ModalBody", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _vm._v(" " + _vm._s(_vm.$t("xHomePremiumLimitText")) + " ")
          ])
        ])
      ]),
      _c("ModalFooter", [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.navToSupportPage()
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xContactSupportUpgrade")) + " ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }